import "./location-type-options.css";

import { RadioButton } from "@tql/ui-components-react/kendo/inputs";

import type { Accessorial } from "~/shared/schemas/accessorial-schema.ts";
import type { SubGroupKey } from "~/shared/types/quote-details-types";

import { usePickupDeliveryDetails } from "../../hooks/use-pickup-delivery-details.ts";

type LocationTypeOptionsProps = {
	name: SubGroupKey;
	disabled?: boolean;
	isOptionSelected: (option: Accessorial) => boolean;
	handleRadioSelectionChange: (option: Accessorial) => void;
	/** Optional: provide location type options directly. If not provided, will use context. */
	locationTypeOptions?: Accessorial[];
};

export const LocationTypeOptions = ({
	name,
	isOptionSelected,
	handleRadioSelectionChange,
	disabled,
	locationTypeOptions: locationTypeOptionsProp,
}: LocationTypeOptionsProps) => {
	// Use provided options or fall back to context
	const contextData = usePickupDeliveryDetails(name);
	const locationTypeOptions =
		locationTypeOptionsProp ?? contextData.locationTypeOptions;

	return (
		<>
			<div className={"location-type-mobile-heading"}>Location Type</div>
			<div
				className={
					"combined-services-container location-type-options-container"
				}
			>
				{locationTypeOptions.map((option) => (
					<div
						key={option.id}
						className={"radio-item"}
						data-location-type={option.name}
					>
						<RadioButton
							checked={isOptionSelected(option)}
							disabled={disabled}
							id={`${name}-option-${option.id}`}
							label={option.name}
							name={`${name}-location-type`}
							onChange={() => handleRadioSelectionChange(option)}
							tabIndex={-1}
						/>
					</div>
				))}
			</div>
		</>
	);
};
